export default ({vehicle: {vehicle_make = ''} = {}} = {}) => vehicle_make;
